import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PrivateProfile } from '../models/private-profile';
import { FirebaseAuthService } from '../_services/firebase-auth.service';


@Injectable()

export class UserEditResolver implements Resolve<any> {

    constructor(private firebaseAuthService: FirebaseAuthService, private afAuth: AngularFireAuth, private router: Router) {
    }


    async resolve(route: ActivatedRouteSnapshot): Promise<PrivateProfile> {

        const firebaseUser = await this.afAuth.currentUser;
        console.log('resolver');

        if  (this.firebaseAuthService.completeRegister) {
            console.log('completar registro!');
            this.router.navigate(['social-network-register']);
            return null;
        }

        return this.firebaseAuthService.getLoguedPrivateProfileUser(firebaseUser.uid).toPromise();
    }

}
